import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=93ae46a4&scoped=true&"
import script from "./TransactionCard.vue?vue&type=script&lang=ts&"
export * from "./TransactionCard.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionCard.vue?vue&type=style&index=0&id=93ae46a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ae46a4",
  null
  
)

export default component.exports